import { useEffect, useState } from 'react';
import { MODAL_TRANSITION_DURATION } from '@/app/components/search/components/Modal/OpenXModal/utils.ts';

const useIsModalMounted = (isOpen: boolean) => {
  const [shouldMount, setShouldMount] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldMount(true);
      return undefined;
    }
    const timeout = setTimeout(() => setShouldMount(false), MODAL_TRANSITION_DURATION);
    return () => clearTimeout(timeout);
  }, [isOpen]);

  return { shouldMount };
};

export default useIsModalMounted;
